export default "__VITE_ASSET__BcCQ0fuj__"